var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0963 31.1804C36.1013 31.1804 34.2136 30.7394 32.5173 29.9531L24.3623 31.6844L26.068 23.5131C25.277 21.8121 24.8336 19.9151 24.8336 17.9154C24.8336 10.6004 30.765 4.66675 38.0846 4.66675C45.4043 4.66675 51.3333 10.6004 51.3333 17.9154C51.3333 25.2304 45.3996 31.1641 38.0846 31.1641",
    fill: "#F25926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0963 31.1804C36.1013 31.1804 34.2136 30.7394 32.5173 29.9531L24.3623 31.6844L26.068 23.5131C25.277 21.8121 24.8336 19.9151 24.8336 17.9154C24.8336 10.6004 30.765 4.66675 38.0846 4.66675C45.4043 4.66675 51.3333 10.6004 51.3333 17.9154C51.3333 25.2304 45.3996 31.1641 38.0846 31.1641",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4662 42.8657L33.2029 40.6023C32.0712 39.4707 30.2396 39.4707 29.1102 40.6023L27.3322 42.3803C26.9356 42.777 26.3336 42.91 25.8202 42.686C23.2419 41.5567 20.6962 39.8463 18.4259 37.576C16.1649 35.315 14.4592 32.781 13.3299 30.212C13.0942 29.6823 13.2319 29.0593 13.6426 28.6463L15.2362 27.0527C16.5312 25.7577 16.5312 23.9283 15.3996 22.7967L13.1339 20.5333C11.6266 19.026 9.18591 19.026 7.67857 20.5333L6.42091 21.791C4.99057 23.2213 4.39557 25.284 4.78057 27.328C5.73257 32.368 8.66324 37.8887 13.3859 42.6137C18.1086 47.3387 23.6292 50.267 28.6716 51.219C30.7156 51.604 32.7782 51.009 34.2086 49.5787L35.4662 48.3233C36.9712 46.816 36.9712 44.373 35.4662 42.8657Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9025 18.0942C31.948 18.1397 31.948 18.2136 31.9025 18.2592C31.8569 18.3047 31.7831 18.3047 31.7375 18.2592C31.6919 18.2136 31.6919 18.1397 31.7375 18.0942C31.7831 18.0486 31.8569 18.0486 31.9025 18.0942",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9826 18.0942C38.0281 18.1397 38.0281 18.2136 37.9826 18.2592C37.937 18.3047 37.8631 18.3047 37.8176 18.2592C37.772 18.2136 37.772 18.1397 37.8176 18.0942C37.8631 18.0486 37.937 18.0486 37.9826 18.0942",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0617 18.0942C44.1072 18.1397 44.1072 18.2136 44.0617 18.2592C44.0161 18.3047 43.9422 18.3047 43.8967 18.2592C43.8511 18.2136 43.8511 18.1397 43.8967 18.0942C43.9422 18.0486 44.0161 18.0486 44.0617 18.0942",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.53d61b6ea57b86a93396b088895306fb.svg";
export { ForwardRef as ReactComponent };